import { ProductViewConfigurator } from '~/types/configurator';
import configuratorChoices from '~/data/configuratorChoices/bagConfiguratorChoices';

let label;
let description;

export default {
    controls: [
        {
            key: 'material',
            keyLabel: 'material',
            label: 'Material',
            choices: [
                configuratorChoices.materials.customStandard,
                configuratorChoices.materials.kraft,
                configuratorChoices.materials.recyclable,
                configuratorChoices.materials.compostable,
                configuratorChoices.materials.metallic,
            ],
            detailsModalLabel: 'Material options:',
        },
        {
            key: 'color',
            keyLabel: 'color',
            label: 'Color',
            displayAsImages: true,
            choices: [
                configuratorChoices.colors.customWhite,
                configuratorChoices.colors.customBrown,
                configuratorChoices.colors.customClear,
            ],
            detailsModalLabel: 'Base color options:',
        },
        {
            key: 'finish',
            keyLabel: 'finish',
            label: 'Finish',
            choices: [
                configuratorChoices.finishes.matte,
                configuratorChoices.finishes.customGloss,
            ],
            detailsModalLabel: 'Finish options:',
        },
        {
            key: 'size',
            keyLabel: 'size',
            label: 'Size',
            choices: [
                {
                    label: (label = '5”w × 9.25”h × 2.875”d'),
                    detailsModalLabel: label,
                    value: '5-x-9.25-x-2.875',
                    description: (description =
                        'Approximately 10–12 oz *Fill testing recommended'),
                    detailsModalDescription: description,
                },
                {
                    label: (label = '3.875”w × 10.5”h × 3.25”d'),
                    detailsModalLabel: label,
                    value: '3.875-x-10.5-x-3.25',
                    description: (description =
                        'Approximately 10–12 oz *Fill testing recommended'),
                    detailsModalDescription: description,
                },
                {
                    label: (label = '7.125”w × 8”h × 3.75”d'),
                    detailsModalLabel: label,
                    value: '7.125-x-8-x-3.75',
                    description: (description =
                        'Approximately 16 oz, 1 lb *Fill testing recommended'),
                    detailsModalDescription: description,
                },
            ],
            detailsModalLabel: 'Size options:',
        },
    ],
} as ProductViewConfigurator;
